<h2 mat-dialog-title>
  <mat-icon>tv</mat-icon>
  Skærmbilleder for {{ paymentTerminal.serialNumber }}
  <span>
    @if (paymentTerminal.chargingStationLocationInfo) {
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationName }} -
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationFullAddress }}
    }
    @if (!paymentTerminal.chargingStationLocationInfo) {
      ingen tilknyttede lokationer
    }
  </span>
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <div class="log-list">
    @for (uiLog of uiLogs(); track uiLog) {
      <adm-ui-log-card [uiLog]="uiLog" (terminalEmulatorEvent)="handleTerminalEmulator($event)"></adm-ui-log-card>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if (paymentTerminal) {
    <div class="unit-identifier">
      <span>Terminal serienummer</span>
      {{ paymentTerminal.serialNumber }}
    </div>
  }

  <button class="actions__button" type="button" mat-dialog-close mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
